import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ButtonContent = ({text, icon, color}) => {
  return (
    <div>
      {
        icon ? (
          <FontAwesomeIcon icon={icon} style={{marginRight: 5}}/>
        ) : null
      }
      { text }
    </div>
  )
}

export default ButtonContent;



// WEBPACK FOOTER //
// ./src/components/ButtonContent.js